import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Footer from '../../common/Footer';
import Header from '../../common/Header';
import './home.css';
import { CalculatorComponent } from '../../common/calculator';
import Partners from '../../common/Partners';
import Faq from '../../common/Faq';
import LendingPartners from '../../common/LendingPartners';
import banner_check from '../../../assets/images/banner_check.svg';
import banner_icon1 from '../../../assets/images/banner_icon1.svg';
import banner_icon2 from '../../../assets/images/banner_icon2.svg';
import banner_icon3 from '../../../assets/images/banner_icon3.svg';
import banner_icon1mob from '../../../assets/images/banner_icon1mob.svg';
import banner_icon2mob from '../../../assets/images/banner_icon2mob.svg';
import banner_icon3mob from '../../../assets/images/banner_icon3mob.svg';
import hmbanner_img from '../../../assets/images/hmbanner_img.webp';
import hmbanner_imgmobile from '../../../assets/images/hmbanner_imgmobile.webp';
import credit_meter from '../../../assets/images/credit-meter.webp';
import hmbanner_img2 from '../../../assets/images/hmbanner_img2.webp';
import star_shape from '../../../assets/images/star_shape.svg';
import star_shape_mobile from '../../../assets/images/star_shape_mobile.svg';
import { useSelector } from 'react-redux';
import LoaderContainer from '../../../components/reusable-ui/common-loader';
import BestOfferModal from '../../common/BestOfferModal';
import history from '../../../history';
import { CREDIT_REPORT_APPLY_ROUTE } from '../../../data/routes-constants';
import { RightArrowLg, RightArrowSm } from '../../../utils/svgExports';
import { LOAN_TYPE } from '../../credit-report/constants';
import CustomModal from '../../../components/reusable-ui/backdrop-modal';
import CtaComponent from '../../../components/reusable-ui/cta';
import { CTA_SIZE, CTA_TYPE } from '../../../data/constants';
import dc_works from '../../../assets/images/dc_works.webp';
import dc_works_mobile from '../../../assets/images/dc_works_mobile.webp';
import useLogin from '../../../hooks/useLogin';

const HomeComponent = () => {
  const [isModalOpen, setIsModalopen] = useState(false);
  const [disclaimerPopup, setDisclaimerPopup] = useState(false);
  const [loanType, setLoanType] = useState('');
  // Define separate state variables for each modal
  const [scrolledPastHero, setScrolledPastHero] = useState(true);
  const [frontImageLoaded, setFrontImageLoaded] = useState(false);
  const heroRef = useRef(null);
  const { isLoading } = useSelector((state) => state.leadsReducer);
  const location = useLocation();
  const { handleLogout } = useLogin();

  useEffect(() => {
    handleLogout(false);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < 1054) {
        setScrolledPastHero(true);
      } else {
        setScrolledPastHero(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolledPastHero]);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  // Handler for the front image load event
  const handleFrontImageLoad = () => {
    setFrontImageLoaded(true);
  };

  const openPersonalModal = () => {
    history.push(CREDIT_REPORT_APPLY_ROUTE + '?loanType=PL');
  };

  const openBusinessModal = () => {
    history.push(CREDIT_REPORT_APPLY_ROUTE + '?loanType=BL');
  };

  const handleRedirection = (e, type) => {
    e.preventDefault();
    setIsModalopen(true);
    setLoanType(type);
  };

  return (
    <div className="capitals_homepage">
      <Header />
      {isLoading && <LoaderContainer />}

      <section
        ref={heroRef}
        className="banner_outerinfos lg:tw-pt-[30px] sm:tw-pt-[96px] sm:tw-border-b-[0px]">
        <div className="container">
          <div className="dc_mainbannerinfos tw-pointer-events-none tw-select-none">
            <h2>
              More Money<b>.</b>{' '}
              <span>
                Fast Money<b>.</b>
              </span>
            </h2>
            <ul>
              <li>
                <span>
                  <img src={banner_check} alt="banner-check" />
                </span>
                Diverse Loan Solutions.
              </li>
              <br className="tw-hidden sm:tw-block" />
              <li>
                <span>
                  <img src={banner_check} alt="banner-check" />
                </span>
                Best rates.
              </li>
              <li>
                <span>
                  <img src={banner_check} alt="banner-check" />
                </span>
                Multiple lenders.
              </li>
            </ul>
          </div>

          <div className="hm_banner_newsec">
            <div className="row">
              <div className="col-md-7">
                <div
                  className={`nw_banner_leftcols ${
                    frontImageLoaded ? 'load-bg-image' : ''
                  } sm:tw-h-auto sm:rounded-[10px] top_hero_banner`}>
                  <div className="row ">
                    <div className="col-md-7">
                      <div className="nw_banner_leftinfos sm:tw-relative sm:tw-max-w-[100%] sm:tw-text-left sm:tw-items-start sm:tw-m-[0px] sm:tw-px-[24px] sm:tw-pb-[62px] tw-overflow-hidden sm:tw-rounded-[20px]">
                        <h6 className="tw-pointer-events-none tw-select-none">
                          Business Loan
                        </h6>
                        <h4 className="tw-pointer-events-none tw-select-none">
                          Quick. easy. super-fast{' '}
                          <br className="tw-hidden sm:tw-block" /> business
                          loans
                        </h4>
                        <button
                          type="button"
                          className="btn btn-primary sm:tw-rounded-[4px] sm:tw-max-w-[122px] sm:tw-min-w-[122px]"
                          onClick={openBusinessModal} // For personal loan modal
                        >
                          Apply Now
                        </button>
                        <img
                          className="tw-hidden sm:tw-block tw-absolute tw-bottom-0 tw-right-[-30px] tw-max-w-[186px] new_banner_img"
                          src={hmbanner_imgmobile}
                          alt="Man"
                        />
                      </div>
                    </div>
                    <div className="col-md-5 tw-pointer-events-none tw-select-none tw-block sm:tw-hidden">
                      <div className="nw_leftpart_right tw-relative tw-h-[100%]">
                        <div className="nw_rightimg tw-absolute tw-bottom-0 tw-right-[90px] tw-w-[100%]">
                          <img src={hmbanner_img} alt="Man" />
                        </div>
                        <div className="nw_rightimg nw_rightimg_mob top_hero_banner_img">
                          <img
                            onLoad={handleFrontImageLoad}
                            src={hmbanner_imgmobile}
                            alt="Man"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="nw_banner_leftcols nw_banner_rightcols sm:tw-h-auto">
                  <div className="nw_banner_leftinfos nw_banner_rightinfos sm:tw-pb-[50px]">
                    <h6 className="tw-pointer-events-none tw-select-none">
                      Personal Loan
                    </h6>
                    <h4 className="tw-pointer-events-none tw-select-none sm:tw-max-w-[100%]">
                      Don't put off your{' '}
                      <br className="tw-hidden sm:tw-block" /> dreams any
                      longer.
                    </h4>
                    <button
                      type="button"
                      className="btn btn-primary sm:tw-rounded-[4px] sm:tw-max-w-[120px] sm:tw-min-w-[122px]"
                      onClick={openPersonalModal} // For business loan modal
                    >
                      Apply Now
                    </button>
                    <div className="nw_banner_rightimg tw-pointer-events-none tw-select-none">
                      <img
                        className="tw-max-w-[264px]"
                        src={hmbanner_img2}
                        alt="Personal Loan"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="credit-score-banner-section tw-flex tw-flex-row tw-justify-between tw-items-start tw-rounded-[24px] tw-bg-[#FFFFFF33] tw-font-jakarta tw-mt-[20px] tw-pr-[50px] tw-pl-[64px] tw-pb-[50px] tw-relative tw-overflow-hidden sm:tw-mt-[30px]">
            <section className="text-section tw-pt-[60px]">
              <h1 className="tw-text-[30px] tw-font-700 tw-mb-[24px] tw-text-[#ffffff] heading-text tw-pointer-events-none tw-select-none">
                Get your credit score & report for free!
                {/* <span className="underline-style">
                  free!
                </span> */}
              </h1>
              <p className="tw-flex tw-flex-row tw-items-center tw-text-[16px] tw-font-500 tw-text-[#FFFFFFE5] tw-mb-[8px] sm:tw-hidden large-screen-text tw-pointer-events-none tw-select-none">
                <RightArrowLg />
                Your credit score helps gives you access to the best loan
                offers!
              </p>
              <p className="tw-flex tw-flex-row tw-items-center tw-text-[16px] tw-font-500 tw-text-[#FFFFFFE5] tw-mb-[46px] sm:tw-hidden large-screen-text tw-pointer-events-none tw-select-none">
                <RightArrowLg />
                Checking credit score via DotPe does not impact credit score
              </p>
              <p className="tw-flex tw-flex-row tw-items-center tw-text-[12px] tw-font-500 tw-text-[#FFFFFFE5] lg:tw-hidden sm:tw-block small-screen-text first-text tw-pointer-events-none tw-select-none">
                <RightArrowSm />{' '}
                <span className="tw-ml-[4px]">
                  {' '}
                  Access to the best loan offers!
                </span>
              </p>
              <p className="tw-flex tw-flex-row tw-items-center tw-text-[12px] tw-font-500 tw-text-[#FFFFFFE5] lg:tw-hidden sm:tw-block small-screen-text tw-mb-[20px] second-text tw-pointer-events-none tw-select-none">
                <RightArrowSm />
                <span className="tw-ml-[4px]">No impact on credit score</span>
              </p>
              <button
                onClick={() =>
                  history.push(CREDIT_REPORT_APPLY_ROUTE + '?loanType=CS')
                }
                className="credit-report-cta tw-font-700 tw-text-[18px] tw-bg-[#ffffff] tw-rounded-[4px] tw-px-[74px] tw-py-[20px] tw-text-[#3351A7] tw-select-none">
                Get credit report
              </button>
            </section>
            <img
              className="credit-banner-image tw-max-w-[338px] tw-absolute tw-right-[86px] tw-bottom-[0px] tw-pointer-events-none tw-select-none"
              src={credit_meter}
              alt="credit-meter"
            />
          </div>

          <div className="nw_banner_btmlinks lg:tw-py-[30px]">
            <ul>
              <li>
                <NavLink
                  className="tw-flex tw-flex-row tw-justify-center tw-items-baseline sm:tw-font-jakarta sm:tw-text-[#ffffff]"
                  to="/"
                  onClick={(e) => handleRedirection(e, LOAN_TYPE.homeLoan)}>
                  <span>
                    <img src={banner_icon1} alt="Home loans" />
                  </span>
                  <span className="bn_mobicon tw-flex tw-flex-row tw-justify-center tw-items-center sm:tw-flex-col">
                    <img src={banner_icon1mob} alt="Home loans" />
                  </span>
                  Home loan
                </NavLink>
                <b className="tw-block sm:tw-hidden"> | </b>
              </li>
              <li>
                <NavLink
                  to="/"
                  className="tw-flex tw-flex-row tw-justify-center tw-items-baseline sm:tw-font-jakarta sm:tw-text-[#ffffff]"
                  onClick={(e) => handleRedirection(e, LOAN_TYPE.creditCard)}>
                  <span>
                    <img src={banner_icon2} alt="Home loans" />
                  </span>
                  <span className="bn_mobicon tw-flex tw-flex-row tw-justify-center tw-items-center sm:tw-flex-col">
                    <img src={banner_icon2mob} alt="Home loans" />
                  </span>
                  Credit card
                </NavLink>
                <b className="tw-block sm:tw-hidden"> | </b>
              </li>
              <li>
                <NavLink
                  to="/"
                  className="tw-flex tw-flex-row tw-justify-center tw-items-baseline sm:tw-font-jakarta sm:tw-text-[#ffffff]"
                  onClick={(e) =>
                    handleRedirection(e, LOAN_TYPE.loanAgainstProperty)
                  }>
                  <span>
                    <img src={banner_icon3} alt="Home loans" />
                  </span>
                  <span className="bn_mobicon tw-flex tw-flex-row tw-justify-center tw-items-center sm:tw-flex-col">
                    <img src={banner_icon3mob} alt="Home loans" />
                  </span>
                  Loan against property
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Partners.jsx */}
      <Partners />

      <section className="dc_sec_space dc_works_outer">
        <div className="container">
          <div className="dc_hdgtitle tw-pointer-events-none tw-select-none">
            How{' '}
            <span>
              DotPe<br></br> Cappitals
            </span>{' '}
            Works?
          </div>
          <div className="dc_works_main">
            <div className="row">
              <div className="col-md-5">
                <div className="dc_work_img sm:tw-relative tw-pointer-events-none tw-select-none">
                  <div className="dc_star_icon dc_star_icon_small sm:tw-absolute sm:tw-top-[-50%]">
                    <img src={star_shape_mobile} alt="star" />
                  </div>
                  <img className="desk_workimg" src={dc_works} alt=""></img>
                  <img
                    className="mobile_work_img"
                    src={dc_works_mobile}
                    alt=""></img>
                  <div className="dc_star_icon tw-flex tw-flex-row tw-justify-end sm:tw-absolute sm:tw-right-[-11px] sm:tw-top-[37%]">
                    <img src={star_shape} alt="star" />
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <div className="dc_work_infos">
                  <ul>
                    <li className="tw-pointer-events-none tw-select-none">
                      <span className="dc_workno">1</span>
                      <div className="dc_workmain_infos">
                        <h4>Show your interest</h4>
                        <p className="tw-mb-[16px]">
                          Forget lengthy forms and wait for quotes. Tell us
                          about your loan needs, and we will do the heavy
                          lifting.
                        </p>
                      </div>
                    </li>
                    <li className="tw-pointer-events-none tw-select-none">
                      <span className="dc_workno">2</span>
                      <div className="dc_workmain_infos">
                        <h4>
                          Smart matching with lowest interest rate<br></br> and
                          a high success rate
                        </h4>
                        <p className="tw-mb-[16px]">
                          Our experts analyze your details and match you with
                          the best banks from our network of over 90 lenders.
                        </p>
                      </div>
                    </li>
                    <li>
                      <span className="dc_workno">3</span>
                      <div className="dc_workmain_infos">
                        <h4 className="tw-pointer-events-none tw-select-none">
                          Fast loan disbursal on<br></br> successful approval
                        </h4>
                        <p className="tw-mb-[16px] tw-pointer-events-none tw-select-none">
                          The entire process is streamlined to take minutes, not
                          weeks. You'll know where you stand quickly and can
                          access your funds faster to achieve your goals.
                        </p>
                        <p className="tw-pointer-events-none tw-select-none tw-text-[14px] sm:tw-text-[12px] tw-mb-[0px]">
                          Note: DotPe Cappitals does not charge any fee for loan
                          facilitation. Any processing fee is charged by the
                          lender directly. If any DotPe Cappitals representative
                          asks for any money directly, please report at{' '}
                        </p>
                        <a
                          href="mailto:customer.support@dotpe.in"
                          className="tw-text-[#002691] tw-text-[14px] sm:tw-text-[12px] sm:tw-leading-[20px] sm:tw-font-jakarta">
                          customer.support@dotpe.in
                        </a>{' '}
                        <span
                          className=" tw-text-[14px] sm:tw-text-[12px] sm:tw-leading-[20px] tw-text-[#00279D] tw-cursor-pointer tw-border-b-[1px] tw-border-dotted tw-border-[#00279D] sm:tw-font-jakarta"
                          onClick={() => setDisclaimerPopup(true)}>
                          Read More
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {disclaimerPopup && (
        <CustomModal
          open={disclaimerPopup}
          customClass={'tw-min-w-[520px] sm:tw-min-w-[100%]'}
          preventBodyScroll={true}
          children={
            <section className="tw-p-[24px] sm:tw-px-[16px] tw-font-roboto sm:tw-text-[14px]">
              <section>
                Dotpe Cappitals is committed to ensuring a safe, transparent,
                and secure experience for all our customers. Please be aware
                that Dotpe Cappitals or any of its employees, representatives,
                or subcontractors will never request payment in exchange for
                loan approval, processing, or sanctioning. Any such request is
                fraudulent and should be treated with caution. If you are
                approached by anyone asking for money to facilitate a loan, do
                not proceed with the payment and report the incident immediately
                to us via{' '}
                <a
                  href="mailto:customer.support@dotpe.in"
                  className="tw-text-[#002691]">
                  customer.support@dotpe.in
                </a>{' '}
                Your vigilance helps us maintain a trustworthy environment, and
                we greatly appreciate your cooperation in safeguarding your
                financial interests.
              </section>
              <section className="tw-flex tw-flex-row tw-justify-end tw-mt-[24px] tw-gap-[12px] sm:tw-mt-[32px]">
                <CtaComponent
                  ctaSize={CTA_SIZE.small}
                  ctaType={CTA_TYPE.secondary_active_cta}
                  onCtaClick={() => setDisclaimerPopup(false)}
                  ctaText={'Okay'}
                  customClass={`tw-w-[150px] tw-py-[10px] tw-bg-[#002691] tw-border-0`}
                  isDisabled={false}></CtaComponent>
              </section>
            </section>
          }
          onClose={() => setDisclaimerPopup(false)}
        />
      )}

      <section className="dc_sec_space dc_choose_outer">
        <div className="container">
          <div className="dc_title_up">Minimum Effort. Maximum Loans.</div>
          <div className="dc_hdgtitle tw-pointer-events-none tw-select-none">
            Why should you choose <br></br>
            <span>DotPe Cappitals</span>?
          </div>
          <div className="dc_hdgtitle_infos tw-pointer-events-none tw-select-none">
            <p className="tw-mb-[16px]">
              We're your one-stop shop for diverse loan solutions, tailored to
              your needs and goals. Whether you want to expand your operations,
              invest in new equipment, or simply manage day-to-day cash flow, we
              have the perfect loan product to empower your growth.
            </p>
          </div>
          <div className="dc_choose_grid tw-pointer-events-none tw-select-none">
            <div className="row">
              <div className="col-md-6">
                <div className="dc_choose_box">
                  <span className="dc_chose_number">01</span>
                  <h3>Fast Disbursals</h3>
                  <p className="tw-font-jakarta tw-text-[18px] tw-leading-[28px] tw-mb-[16px] sm:tw-text-[12px] sm:tw-leading-[20px]">
                    Our dedicated team works tirelessly to ensure your loan
                    application is processed quickly, so you receive the funds
                    you need even faster.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="dc_choose_box">
                  <span className="dc_chose_number">02</span>
                  <h3>Personalized Matching</h3>
                  <p className="tw-font-jakarta tw-text-[18px] tw-leading-[28px] tw-mb-[16px] sm:tw-text-[12px] sm:tw-leading-[20px]">
                    We don't believe in a one-size-fits-all approach. We analyze
                    your unique profile, credit score, and financial
                    circumstances to match you with the most suitable loan
                    options from a vast network of partners.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="dc_choose_counter">
            <div className="row">
              <div className="col-md-4">
                <div className="dc_choose__count_box dc_choose__count_box_first">
                  <div className="dc_choose_ins">
                    <h3 className="lg:tw-text-[46px] tw-pointer-events-none tw-select-none">
                      30+
                    </h3>
                    <h6 className="tw-pointer-events-none tw-select-none">
                      Marquee <br />
                      Lenders
                    </h6>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="dc_choose__count_box">
                  <div className="dc_choose_ins sm:tw-pl-[10px] sm:tw-gap-10">
                    <h3 className="lg:tw-text-[46px] tw-pointer-events-none tw-select-none tw-pb-0 sm:tw-leading-[1]">
                      80 Lakh+
                    </h3>
                    <h6 className="tw-pointer-events-none tw-select-none">
                      Businesses <br />
                      Empowered
                    </h6>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="dc_choose__count_box">
                  <div className="dc_choose_ins">
                    <h3 className="lg:tw-text-[46px] tw-pointer-events-none tw-select-none">
                      2.45 Cr+
                    </h3>
                    <h6 className="tw-pointer-events-none tw-select-none">
                      Consumers Enabled
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="dc_sec_space dc_choose_outer dc_calci_outer">
        <div className="container">
          <div className="dc_title_up tw-pointer-events-none tw-select-none">
            EMI CALCULATOR
          </div>
          <div className="dc_hdgtitle tw-pointer-events-none tw-select-none">
            Calculate Loan EMIs
            <br /> in 3 easy steps!
          </div>
          <div className="dc_calci_main sm:tw-pb-[50px]">
            <CalculatorComponent />
          </div>

          <div className="hm_banner_newsec hm_calci_newsec">
            <div className="row">
              <div className="col-md-7">
                <div className="nw_banner_leftcols_brdr">
                  <div className="nw_banner_leftcols bottom_card_image">
                    <div className="row">
                      <div className="col-md-7">
                        <div className="nw_banner_leftinfos">
                          <h6 className="tw-pointer-events-none tw-select-none">
                            Business Loan
                          </h6>
                          <h4 className="tw-text-[#000000] tw-pointer-events-none tw-select-none sm:tw-mb-[20px]">
                            Quick. easy. super-fast business loans
                          </h4>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={openBusinessModal} // For personal loan modal
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                      <div className="col-md-5 tw-pointer-events-none tw-select-none">
                        <div className="nw_leftpart_right">
                          <div className="nw_rightimg tw-bottom-[-24px]">
                            <img src={hmbanner_img} alt="Man" />
                          </div>
                          <div className="nw_rightimg nw_rightimg_mob">
                            <img src={hmbanner_imgmobile} alt="Man" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="nw_banner_leftcols nw_banner_rightcols">
                  <div className="nw_banner_leftinfos nw_banner_rightinfos">
                    <h6 className="tw-pointer-events-none tw-select-none">
                      Personal Loan
                    </h6>
                    <h4 className="tw-pointer-events-none tw-select-none">
                      Don't put off your dreams any longer.
                    </h4>

                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={openPersonalModal} // For business loan modal
                    >
                      Apply Now
                    </button>
                    <div className="nw_banner_rightimg tw-pointer-events-none tw-select-none">
                      <img
                        className="tw-max-w-[264px]"
                        src={hmbanner_img2}
                        alt="Personal Loan"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="faq-section">
        <Faq />
      </section>

      <LendingPartners />

      <Footer scrolledUp={scrolledPastHero} />

      {isModalOpen && (
        <BestOfferModal
          isModalOpen={isModalOpen}
          setIsModalopen={setIsModalopen}
          loanType={loanType}
        />
      )}
    </div>
  );
};

export default HomeComponent;
